import { ExperimentConfig, ExperimentDefinition } from './types';

function defineExperiment<const V extends Record<string, string>>(
	exp: ExperimentDefinition<V>
): ExperimentDefinition<V> {
	return exp;
}

// DeepLinks
// ?new_preferred_variant=[EXP_NAME]:[VARIANT_NAME]
// ?new_remove_preferred_experiment=[EXP_NAME]
export const experimentConfig = {
	JW_APP_DOWNLOAD_EXP_1: defineExperiment({
		variants: {
			CONTROL: 'control',
			VARIANT_1: 'variant_1',
			VARIANT_2: 'variant_2',
		},
		routes: ['app.detail.movies', 'app.detail.show'],
		tabs: [],
		userTypes: ['LOGGED_OUT'],
	}),
	// ?new_preferred_variant=PP_FREETRIAL_EXP_2:control
	// ?new_preferred_variant=PP_FREETRIAL_EXP_2:variant_1
	// ?new_preferred_variant=PP_FREETRIAL_EXP_2:variant_2
	// ?new_preferred_variant=PP_FREETRIAL_EXP_2:variant_3
	// ?new_remove_preferred_experiment=PP_FREETRIAL_EXP_2
	PP_FREETRIAL_EXP_2: defineExperiment({
		variants: {
			CONTROL: 'control',
			VARIANT_1: 'variant_1',
			VARIANT_2: 'variant_2',
			VARIANT_3: 'variant_3',
		},
		routes: ['app.detail.movies', 'app.detail.show', 'app.detail.show.season'],
		tabs: [],
		userTypes: ['LOGGED_OUT', 'LOGGED_IN'],
	}),
	// ?new_preferred_variant=MRR_BANNER_EXP:control
	// ?new_preferred_variant=MRR_BANNER_EXP:variant_1
	// ?new_preferred_variant=MRR_BANNER_EXP:variant_2
	// ?new_preferred_variant=MRR_BANNER_EXP:variant_3
	// ?new_preferred_variant=MRR_BANNER_EXP:variant_4
	// ?new_preferred_variant=MRR_BANNER_EXP:variant_5
	// ?new_preferred_variant=MRR_BANNER_EXP:variant_6
	// ?new_remove_preferred_experiment=MRR_BANNER_EXP
	MRR_BANNER_EXP: defineExperiment({
		variants: {
			CONTROL: 'control',
			VARIANT_1: 'variant_1',
			VARIANT_2: 'variant_2',
			VARIANT_3: 'variant_3',
			VARIANT_4: 'variant_4',
			VARIANT_5: 'variant_5',
			VARIANT_6: 'variant_6',
		},
		routes: [],
		tabs: ['detail'],
		userTypes: ['LOGGED_IN', 'LOGGED_OUT'],
	}),
	//?new_preferred_variant=SR_BACKDROP_BB_IMPACT:variant_1
	//?new_preferred_variant=SR_BACKDROP_BB_IMPACT:control
	//?new_remove_preferred_experiment=SR_BACKDROP_BB_IMPACT
	SR_BACKDROP_BB_IMPACT: defineExperiment({
		variants: {
			CONTROL: 'control',
			VARIANT_1: 'variant_1',
		},
		routes: [],
		tabs: ['detail'],
		userTypes: ['LOGGED_OUT', 'LOGGED_IN'],
	}),
	// ?new_preferred_variant=PP_SWIPER_EXP:control
	// ?new_preferred_variant=PP_SWIPER_EXP:variant_1
	// ?new_preferred_variant=PP_SWIPER_EXP:variant_2
	// ?new_preferred_variant=PP_SWIPER_EXP:variant_3
	// ?new_preferred_variant=PP_SWIPER_EXP:variant_4
	// ?new_remove_preferred_experiment=PP_SWIPER_EXP
	PP_SWIPER_EXP: defineExperiment({
		variants: {
			CONTROL: 'control',
			VARIANT_1: 'variant_1',
			VARIANT_2: 'variant_2',
			VARIANT_3: 'variant_3',
			VARIANT_4: 'variant_4',
		},
		routes: [],
		tabs: ['detail'],
		userTypes: ['LOGGED_OUT'],
	}),
	// ?new_preferred_variant=SR_CINEMA_IMPACT:control
	// ?new_preferred_variant=SR_CINEMA_IMPACT:variant_1
	SR_CINEMA_IMPACT: defineExperiment({
		variants: {
			CONTROL: 'control',
			VARIANT_1: 'variant_1',
		},
		routes: [],
		tabs: [],
		userTypes: ['LOGGED_OUT', 'LOGGED_IN'],
	}),
} satisfies ExperimentConfig;
